import React from 'react';
import {
  BookOutlined,
  CheckOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  FieldBinaryOutlined,
  FileTextOutlined,
  PicCenterOutlined,
  PlayCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { AnswerType, GenerationType } from '@data/sdk/match';
import { Namespace } from '@data/utils/enums';
import { AntdTag } from '@ui/components';

const typeIconMap = {
  answer_types: {
    [AnswerType.Boolean]: <CheckOutlined />,
    [AnswerType.Date]: <ClockCircleOutlined />,
    [AnswerType.Number]: <FieldBinaryOutlined />,
    [AnswerType.String]: <FileTextOutlined />,
    [AnswerType.Options]: <CheckSquareOutlined />,
    [AnswerType.MultipleOptions]: <CheckSquareOutlined />,
  },
  generation_types: {
    [GenerationType.Aggregated]: <PicCenterOutlined />,
    [GenerationType.Researcher]: <SearchOutlined />,
    [GenerationType.Standard]: <BookOutlined />,
    [GenerationType.AiGenerated]: <PlayCircleOutlined />,
  },
};

const typeColorMap = {
  answer_types: 'default',
  generation_types: 'green',
};

type TypeTagProps = {
  tagType: keyof typeof typeIconMap;
  type?: AnswerType | GenerationType;
};

export const TypeTag = ({ tagType, type }: TypeTagProps) => {
  const { t } = useTranslation([Namespace.ADMIN]);

  return (
    <AntdTag
      color={typeColorMap[tagType]}
      icon={typeIconMap[tagType][type as keyof (typeof typeIconMap)[typeof tagType]]}
    >
      {t(`questions_library.filters_options.${tagType}.${type}`)}
    </AntdTag>
  );
};
